module.exports = __webpack_public_path__ + "static/media/sale-mtc-mobile.8e3efc02.png";